import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect"
import { Japanese } from "flatpickr/dist/l10n/ja.js"

export default class extends Controller {
  connect() {
    const url = new URL(window.location.href)
    const mode = url.searchParams.get("mode") || "monthly"

    flatpickr(this.element, {
      locale: Japanese,
      altInput: true,

      dateFormat: mode === "yearly" ? "Y" : "Y-m",
      altFormat: mode === "yearly" ? "Y年" : "Y年m月",

      plugins: mode === "yearly" ? [] : [
        new monthSelectPlugin({
          shorthand: false,
          dateFormat: "Y-m",
          altFormat: "Y年m月"
        })
      ],

      onChange: (selectedDates, dateStr) => {
        const newUrl = new URL(window.location.href)

        const currentMode = newUrl.searchParams.get("mode") || "monthly"

        if (currentMode === "yearly") {
          const year = selectedDates[0].getFullYear()
          newUrl.searchParams.set("year", year)
          newUrl.searchParams.delete("month")
        } else {
          const [year, month] = dateStr.split("-")
          newUrl.searchParams.set("year", year)
          newUrl.searchParams.set("month", month)
        }

        newUrl.searchParams.set("page", "1")

        Turbo.visit(newUrl.toString(), { frame: "table_body" })
      }
    })
  }
}